import { z } from 'zod';

import { TSDGoodsItemSchema } from './TSDGoodsItemSchema';
import { AdditionalSupplyChainActorSchema, PersonSchema, TransportEquipmentSchema } from './utils';

export const TSDHouseSchema = z.object({
  referenceNumberUCR: z.string().optional().nullable(),
  totalGrossMass: z.string().optional().nullable(),
  totalNumberOfPackages: z.string().optional().nullable(),
  consignor: PersonSchema,
  consignee: PersonSchema,
  notifyParty: PersonSchema,
  additionalSupplyChainActor: AdditionalSupplyChainActorSchema,
  transportEquipment: TransportEquipmentSchema,
  receptacle: z
    .array(
      z
        .object({
          identificationNumber: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  transportDocuments: z
    .array(
      z
        .object({
          type: z.string().optional().nullable(),
          referenceNumber: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  previousDocuments: z
    .array(
      z
        .object({
          type: z.string().optional().nullable(),
          referenceNumber: z.string().optional().nullable(),
          goodsItemIdentifier: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  additionalInformation: z
    .array(
      z
        .object({
          code: z.string().optional().nullable(),
          text: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  supportingDocuments: z
    .array(
      z
        .object({
          type: z.string().optional().nullable(),
          referenceNumber: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  batches: z
    .array(
      z.object({
        id: z.any().optional().nullable(),
        name: z.string().optional().nullable(),
      }),
    )
    .optional(),
});
export type TSDViewHouseFormValues = z.infer<typeof TSDHouseSchema>;

export const houseConsignmentWithGoodsItemsSchema = TSDHouseSchema.extend({
  consignmentItems: z.array(TSDGoodsItemSchema).optional(),
});

export const TSDConsignmentSchema = z.object({
  master: houseConsignmentWithGoodsItemsSchema.optional().nullable(),
  houseConsignment: z.array(houseConsignmentWithGoodsItemsSchema).optional(),
});
export type TSDViewConsignmentFormValues = z.infer<typeof TSDConsignmentSchema>;
